import { FC, PropsWithChildren, useRef } from "react";
import styled from "styled-components";

import useOnClickOutside from "@/hooks/useOnClickOutside";
import { scrollBarStyles } from "@/utils/theme";

const DropDown = styled.div`
  width: 188px;
  background: ${({ theme }) => theme.colors.white};
  z-index: ${({ theme }) => theme.zIndex[2]};
  position: absolute;
  right: 0;
  top: calc(100% + 10px);
  border-radius: 4px;
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
  max-height: 55vh;
  overflow-y: auto;
  ${scrollBarStyles};
`;

interface Props {
  onClose: () => void;
  className?: string;
}

const FiltersDropdown: FC<PropsWithChildren<Props>> = ({
  onClose,
  className,
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, onClose);

  return (
    <DropDown className={className} ref={ref}>
      {children}
    </DropDown>
  );
};

export default FiltersDropdown;
